import apiService from '@/member/services/apiService'

const getDefaultState = () => {
  return {}
}

const state = getDefaultState()

const mutations = {}

const actions = {
  async all({ commit }, payload) {
    const apiResult = await apiService.get(route('member.fcs.unit.all'), payload)
    if (apiResult.success && apiResult.data) {
      return apiResult.data
    }
    return false
  },
}

export default {
  state,
  mutations,
  actions,
}
